export default __webpack_public_path__ + "static/1-06d8ac82ec5e44e9073fb6fa86a494f3.png";